"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("main.customer", {
      url: "customer",
      resolve: {
        list: [
          "$stateParams",
          "Customer",
          function ($stateParams, Customer) {
            return Customer.list().$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/Commom/customer/views/customer.list.html",
          controller: "customerListCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.customer-upload", {
      url: "customer/upload",
      resolve: {
        model: [
          function () {
            return {};
          },
        ],
        maxAllowedFileSize: [
          "$stateParams",
          "Internal",
          function ($stateParams, Internal) {
            return Internal.parameters({ entry: "MaxAllowedFileSize" })
              .$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/Commom/customer/views/customer.upload.html",
          controller: "customerUploadCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.customer-edit", {
      url: "customer/:id",
      resolve: {
        model: [
          "$stateParams",
          "Customer",
          function ($stateParams, Customer) {
            if ($stateParams.id) {
              return Customer.get({ id: $stateParams.id }).$promise;
            }

            return {};
          },
        ],
        states: [
          "Internal",
          function (Internal) {
            return Internal.states().$promise;
          },
        ],
        customersTypes: [
          "Customer",
          function (Customer) {
            return Customer.customersTypes().$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/Commom/customer/views/customer.edit.html",
          controller: "customerEditCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
